var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Index"},[_c('top-bar'),_c('side-bar'),_c('router-view',{staticClass:"container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }